import { ReactComponent as SynOpsLogoSvg } from "../../static/images/SynOpsCloverBig.svg";

export default SynOpsLogoSvg;
